import { performance, boundary, maxDrawdown } from './performance.mjs';

// Only compare actual valuations on shared dates; never invent missing prices.
export function compareFunds(funds, period, asOf) {
  if(funds.length!==2||funds.some(f=>!f)||funds[0].id===funds[1].id)return {reason:'Odaberite dva različita fonda.',series:[]};
  const results=funds.map(f=>performance(f,period,asOf));
  const invalid=results.findIndex(r=>r.value===null);
  if(invalid!==-1)return {reason:`${funds[invalid].name}: ${results[invalid].reason}`,series:[]};
  const maps=results.map(r=>new Map(r.points.map(p=>[p.date,p.value])));
  const dates=[...maps[0].keys()].filter(d=>maps[1].has(d));
  const start=dates[0],end=dates.at(-1),limit=boundary(asOf,period);
  if(dates.length<2||start>limit||Date.parse(limit)-Date.parse(start)>7*86400000||Date.parse(asOf)-Date.parse(end)>7*86400000)return {reason:'Za odabrano razdoblje nema zajedničkih cijena dovoljno blizu početnog i završnog datuma. Pokušajte s drugim razdobljem.',series:[]};
  const series=funds.map((fund,i)=>{
    const first=maps[i].get(start),last=maps[i].get(end);
    const points=dates.map(date=>({date,value:(maps[i].get(date)/first-1)*100}));
    const ownPoints=fund.history.filter(p=>p.date>=start&&p.date<=end);
    const drawdown=maxDrawdown(ownPoints);
    return {fund,points,value:(last/first-1)*100,drawdown:drawdown?.value??0};
  });
  return {start,end,series,reason:null};
}
